export const sxStyle = {
  img: {
    width: '100%',
    objectFit: 'cover',
    borderRadius: '8px',
    height: {
      xs: 140,
      sm: 200,
    },
    display: 'block',
    mx: 'auto',
  },

  skeletonImg: {
    width: '100%',
    borderRadius: '8px',
    height: {
      xs: 140,
      sm: 200,
    },
  },

  wrapper: {
    position: 'relative',

    // Oculta flechas en mobile siempre
    '& .swiper-button-prev, & .swiper-button-next': {
      display: 'none !important',

      // En desktop se muestran solo si showArrows=true
      '@media (min-width:600px)': {
        display: 'flex !important',
        background: '#fff',
        width: 32,
        height: 32,
        borderRadius: '50%',
        boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },

    '& .swiper-button-prev::after, & .swiper-button-next::after': {
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#333',
    },
  },
};
